import React, { useContext, useEffect, useState } from 'react'
import { ConfigContext } from '../../Context/ConfigContext'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { ContentLoader, NoRecords } from "../../Components/Shimmer"
import { DateFormaterMonth } from '../GlobalFunctions'

const AssignedItem = () => {
  const { apiURL, apiHeaderJson } = useContext(ConfigContext)
  const { project_id } = useParams()

  const [loadingList, setLoadingList] = useState(true)
  const [projectselectedItems, setProjectselectedItems] = useState([])
  const [next, setNext] = useState(false);
  const [prev, setPrev] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const getProjectItemList = async () => {
    try {
      setLoadingList(true)
      const response = await axios.get(
        `${apiURL}api/requests/GetProjectItems`,
        {
          params: { project_id, page, limit },
          headers: apiHeaderJson
        }
      )

      const { data, success, next, prev, page: currentPage, total_records, total_pages } = response.data

      if (success) {
        setProjectselectedItems(data)
        setNext(next)
        setPrev(prev)
        setPage(currentPage)
        setTotalRecords(total_records)
        setTotalPages(total_pages)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingList(false)
    }
  }

  useEffect(() => {
    getProjectItemList()
  }, [project_id, page, limit])

  return (
    <div className="col-xxl-12">
      <div className="card">
        <div className="card-header">
          <h5 className="card-title mb-0">Items List</h5>
        </div>

        <div className="card-body">
          {loadingList ? (
            <ContentLoader />
          ) : projectselectedItems.length === 0 ? (
            <NoRecords />
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle">
                <thead className="table-light">
                  <tr>
                    <th>ID</th>
                    <th>Item Name</th>
                    <th>Price (QAR)</th>
                    <th>Received Quantity</th>
                    <th>Total Quantity</th>
                    <th>Delivery Date</th>
                  </tr>
                </thead>

                <tbody>
                  {projectselectedItems.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item?.item_name || '-'}</td>
                      <td>{item?.pi_item_price ?? '-'}</td>
                      <td>{item?.pi_item_received_qty ?? '-'}</td>
                      <td>{item?.pi_item_qty ?? '-'}</td>
                      <td>
                        {item?.pi_item_delivery_date
                          ? DateFormaterMonth(item.pi_item_delivery_date)
                          : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="table-light">
                  <tr>
                    <th colSpan={10}>
                      <div className="d-flex justify-content-between align-items-center">
                        {/* PREV */}
                        <button
                          className="btn btn-warning btn-label"
                          onClick={() => prev && setPage(page - 1)}
                          disabled={!prev}
                        >
                          <i className="ri-arrow-left-line label-icon me-2"></i> Previous
                        </button>

                        {/* Info */}
                        <small>
                          Total Records: {totalRecords} | Total Pages: {totalPages} |
                          Current Page: {page}
                        </small>

                        {/* Page Select */}
                        <select
                          className="form-select w-auto"
                          value={page}
                          onChange={(e) => setPage(Number(e.target.value))}
                        >
                          {Array.from({ length: totalPages }, (_, i) => (
                            <option key={i + 1} value={i + 1}>
                              {i + 1}
                            </option>
                          ))}
                        </select>

                        {/* NEXT */}
                        <button
                          className="btn btn-primary btn-label"
                          onClick={() => next && setPage(page + 1)}
                          disabled={!next}
                        >
                          Next <i className="ri-arrow-right-line label-icon ms-2"></i>
                        </button>
                      </div>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AssignedItem
